import { pageurl } from '@constants/pageurl';
import { usePartyCustomization } from '@hooks/usePartyCustomization';
import queryString from 'query-string';
import type React from 'react';
import { useLocation } from 'react-router';

import { type IActions } from '../../interface/IAction';
import { type IStates } from '../../interface/IReducer';
import DataWrapper from '../../wrapper/data-wrapper';
import Footer from './footer';
import GlobalRightSection from './global-right-section';
import Header from './header';
import { AllProviders } from './providers';
import ScrollIntoViewController from './ScrollIntoViewController';
import { ChildrenContainer, HeaderBackgroundOverLay, MainContainer } from './styled';

const Dashboard = ({ children }: { children?: any }) => (
	<DataWrapper nowrapper='true'>
		<DashboardChild>
			{children}
			<Footer />
		</DashboardChild>
	</DataWrapper>
);
interface IDashboardChild {
	states?: IStates;
	children: any;
}

const DashboardChild: React.FC<IDashboardChild> = ({ states, children, ...props }) => {
	const { setPageSection } = props as unknown as IActions;
	const { pathname, search } = useLocation();

	const dataPartyGuid = states?.agent?.partyguid;

	// The party logo shown in the header comes from the (CSP-permitted) published
	// customization rather than the party's own `logo` field, which may point at a
	// blocked external host. No party guid in the URL → the hook no-ops (null).
	const { party, election } = queryString.parse(search);
	const { data: customization } = usePartyCustomization(party as string, election as string);

	// The landing page renders its own branded header (LandingHeader), so the
	// shared party-context header is suppressed there to avoid a double header.
	const isLandingPage = pathname === pageurl.OVERVIEW;

	return (
		<MainContainer>
			{!isLandingPage && (
				<Header
					setPageSection={setPageSection}
					dataPartyGuid={dataPartyGuid}
					logoUrl={customization?.logoUrl ?? null}
				/>
			)}
			<HeaderBackgroundOverLay />
			<ScrollIntoViewController>
				<AllProviders
					states={states!}
					actions={props as unknown as IActions}
				>
					<ChildrenContainer>
						<GlobalRightSection />
						{children}
					</ChildrenContainer>
				</AllProviders>
			</ScrollIntoViewController>
		</MainContainer>
	);
};

export default Dashboard;
